import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const ratingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllReviews: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.rating}`,
        method: "POST",
        body,
      }),
    }),

    ratingResponse: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.ratingResponse}${id}/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetAllReviewsMutation, useRatingResponseMutation } =
  ratingApi;
